import { useState, useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > 50);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-lg font-bold font-heading">
              快
            </span>
            <span className={`text-xl font-heading font-bold transition-colors ${
              scrolled || !isHome ? 'text-foreground-950' : 'text-white'
            }`}>
              快猫
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors hover:text-primary-500 whitespace-nowrap ${
                scrolled || !isHome ? 'text-foreground-700' : 'text-white/90'
              } ${location.pathname === '/' ? 'text-primary-500' : ''}`}
            >
              首页
            </Link>
            <Link
              to="/category/short-video"
              className={`text-sm font-medium transition-colors hover:text-primary-500 whitespace-nowrap ${
                scrolled || !isHome ? 'text-foreground-700' : 'text-white/90'
              } ${location.pathname.startsWith('/category') ? 'text-primary-500' : ''}`}
            >
              内容分类
            </Link>
            <Link
              to="/category/monetization"
              className={`text-sm font-medium transition-colors hover:text-primary-500 whitespace-nowrap ${
                scrolled || !isHome ? 'text-foreground-700' : 'text-white/90'
              }`}
            >
              变现攻略
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors hover:text-primary-500 whitespace-nowrap ${
                scrolled || !isHome ? 'text-foreground-700' : 'text-white/90'
              } ${location.pathname === '/about' ? 'text-primary-500' : ''}`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/category/short-video"
              className="px-4 py-2 text-sm font-medium rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              开始创作
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl ${
              scrolled || !isHome ? 'text-foreground-950' : 'text-white'
            }`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/60">
          <div className="px-4 py-3 flex flex-col gap-2">
            <Link to="/" className="px-3 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-md transition-colors whitespace-nowrap">首页</Link>
            <Link to="/category/short-video" className="px-3 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-md transition-colors whitespace-nowrap">内容分类</Link>
            <Link to="/category/monetization" className="px-3 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-md transition-colors whitespace-nowrap">变现攻略</Link>
            <Link to="/about" className="px-3 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-md transition-colors whitespace-nowrap">关于我们</Link>
            <Link to="/category/short-video" className="mt-1 px-4 py-2.5 text-sm font-medium rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors text-center whitespace-nowrap cursor-pointer">开始创作</Link>
          </div>
        </div>
      )}
    </nav>
  );
}